"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserProjectTemplate = void 0;
const typeorm_1 = require("typeorm");
const BaseEntity_1 = require("../../BaseEntity");
const User_1 = require("./User");
const Project_1 = require("../../project/entity/Project");
let UserProjectTemplate = class UserProjectTemplate extends BaseEntity_1.BaseEntity {
};
exports.UserProjectTemplate = UserProjectTemplate;
__decorate([
    (0, typeorm_1.ManyToOne)(() => User_1.User),
    __metadata("design:type", User_1.User)
], UserProjectTemplate.prototype, "user", void 0);
__decorate([
    (0, typeorm_1.RelationId)((upt) => upt.user),
    __metadata("design:type", String)
], UserProjectTemplate.prototype, "userId", void 0);
__decorate([
    (0, typeorm_1.ManyToOne)(() => Project_1.Project),
    __metadata("design:type", Project_1.Project)
], UserProjectTemplate.prototype, "project", void 0);
__decorate([
    (0, typeorm_1.RelationId)((upt) => upt.project),
    __metadata("design:type", String)
], UserProjectTemplate.prototype, "projectId", void 0);
exports.UserProjectTemplate = UserProjectTemplate = __decorate([
    (0, typeorm_1.Entity)()
], UserProjectTemplate);
